module.exports = __webpack_public_path__ + "img/1-5.2f2ea3bd.png";